import { alpha, Stack, SvgIcon, SvgIconProps } from '@mui/material'
import { TablerIcon } from '@tabler/icons-react'

export type CustomIconWrapperProps = {
  Icon: TablerIcon
  color: Exclude<NonNullable<SvgIconProps['color']>, 'inherit' | 'disabled' | 'action'> | 'tertiary'
}
export const CustomIconWrapper = ({ Icon, color }: CustomIconWrapperProps) => {
  return (
    <Stack
      sx={{
        p: 1,
        backgroundColor: (t) => alpha(t.palette[color].main, 0.12),
        borderRadius: '50%',
      }}
    >
      <SvgIcon fontSize="small" sx={{ color: (t) => t.palette[color].main }}>
        <Icon />
      </SvgIcon>
    </Stack>
  )
}
